'use strict';

const CookieCategory = {
    STRICTLY_NECESSARY: 'C0001',
    PERFORMANCE: 'C0002',
    FUNCTIONAL: 'C0003',
    TARGETING: 'C0004',
};

$(document).ready(function () {
    var init = setInterval(function () {
        if (typeof OneTrust !== 'undefined') {
            clearInterval(init);
            OneTrust.OnConsentChanged(function () {
                checkCookieStatus(true); // check cookie status on Consent changed
            });

            checkCookieStatus(false);
        }
    }, 1500);

    function checkCookieStatus(consentChangedForAccept) {
        var categories = [CookieCategory.TARGETING, CookieCategory.PERFORMANCE, CookieCategory.FUNCTIONAL];

        var oneTrustRequired = true;
        for (var i = 0; i < categories.length; i++) {
            if (!OnetrustActiveGroups.includes(categories[i])) {
                oneTrustRequired = false;
                break;
            }
        }

        if (!oneTrustRequired) {
            document.cookie = "CRITEO_RETAILER_VISITOR_COOKIE=; Max-Age=0; path=/";
            document.cookie = "coveo_visitorId=; Max-Age=0; path=/";
            scanYoutubeVideoFromScriptJS();
            scanPageByJsVideoClass(document.querySelectorAll('.js-video'));
            scanPageByEvenementWrapVideosClass(document.querySelectorAll('.evenement-wrap-videos'));
            scanPageBySectionVideoClass(document.querySelectorAll('.section-video__video'));
            scanGenericPageByIframeElement(document.getElementsByTagName("iframe"));
        } else if (consentChangedForAccept) { //reload page to show youtube videos
            location.reload();
        }
    }

    function scanYoutubeVideoFromScriptJS() {
        var script = document.getElementsByTagName("script");
        for (var i = 0; i < script.length; i++) {
            if (typeof script[i].src !== "undefined" && script[i].src.includes("youtube")) {
                script[i].setAttribute("class", "optanon-category-C0004");
                script[i].setAttribute("type", "text/plain");
            }
        }
    }

    function scanPageByJsVideoClass(selector) {
        for (var i = 0; i < selector.length; i++) {
            var pElement = selector[i].getElementsByTagName("p");
            selector[i].outerHTML = displayMessage(true, pElement[0].outerText);
        }
        bindOneTrustModalConsent();
    }

    function scanPageByEvenementWrapVideosClass(selector) {
        for (var i = 0; i < selector.length; i++) {
            selector[i].outerHTML = displayMessage(false);
        }
        bindOneTrustModalConsent();
    }

    function scanPageBySectionVideoClass(selector) {
        for (var i = 0; i < selector.length; i++) {
            var iframeElement = selector[i].getElementsByTagName("iframe");
            scanGenericPageByIframeElement(iframeElement);
        }
    }

    function scanGenericPageByIframeElement(iframeElement) {
        if (iframeElement.length > 0 && iframeElement[0].src.includes("youtube")) {
            iframeElement[0].outerHTML = displayMessage(false);
        }
        bindOneTrustModalConsent();
    }

    function bindOneTrustModalConsent() {
        $('.showCookiePopUpBtn').on('click', function () {
            $('.ot-floating-button__open').click();
        });
    }

    function displayMessage(thumbnail, title) {
        if (thumbnail) {
            return lang === 'fr' ?
                "<div class=\"video-container-disabled\">Nous ne pouvons afficher ce contenu, car vous avez refusé l'utilisation des témoins (cookies) sur ce site Web. Pour rendre votre expérience optimale, veuillez activer les témoins de performance, personnalisation et marketing dans le <a class=\"showCookiePopUpBtn\" href=\"#\">centre de préférences.</a></div> " + title + "</p>"
                : "<div class=\"video-container-disabled\">We are unable to display this content because you have refused the use of cookies on this website. To optimize your experience, please enable the performance, functional and marketing cookies in the <a class=\"showCookiePopUpBtn\" href=\"#\">preferences center.</a></div> " + title + "</p>";
        }

        return lang === 'fr' ?
            "<p>Nous ne pouvons afficher ce contenu, car vous avez refusé l'utilisation des témoins (cookies) sur ce site Web. Pour rendre votre expérience optimale, veuillez activer les témoins de performance, personnalisation et marketing dans le <a class=\"showCookiePopUpBtn\" href=\"#\">centre de préférences.</a></p>" :
            "<p>We are unable to display this content because you have refused the use of cookies on this website. To optimize your experience, please enable the performance, functional and marketing cookies in the <a class=\"showCookiePopUpBtn\" href=\"#\">preferences center.</a></p>";
    }
});

/**
 * Indicates if user has consented to a specific cookie category.
 * @example if (UserCookieConsent.isTargetingConsented()) { ... }
 */
let UserCookieConsent = function () {
    const _isConsented = function (category) {
        if (typeof category === 'undefined' || typeof OnetrustActiveGroups === 'undefined') {
            return false;
        }
        return OnetrustActiveGroups.includes(category);
    };

    const _isStrictlyNecessaryConsented = function () {
        return _isConsented(CookieCategory.STRICTLY_NECESSARY);
    };

    const _isPerformanceConsented = function () {
        return _isConsented(CookieCategory.PERFORMANCE);
    };

    const _isFunctionalConsented = function () {
        return _isConsented(CookieCategory.FUNCTIONAL)
    };

    const _isTargetingConsented = function () {
        return _isConsented(CookieCategory.TARGETING);
    };

    return {
        isStrictlyNecessaryConsented: _isStrictlyNecessaryConsented,
        isPerformanceConsented: _isPerformanceConsented,
        isFunctionalConsented: _isFunctionalConsented,
        isTargetingConsented: _isTargetingConsented,
        isConsented: _isConsented
    };
}();